<template>
  <div id="pendingList" v-loading.fullscreen.lock="pageLoading">
    <div class="main">
      <filter-frame
        :filter-form="paymentFilter"
        :autoSearch="true"
        @search="searchHandle"
        @clear="searchHandle({})"
      />
      <div class="title_bar">
        <div class="left">
          <div class="left-left">
            <div class="choose-count">
              {{ $t("SmartLocker.SelectCountTitle") }}<span>{{ selectionData.length }}</span>{{ $t('SmartLocker.SelectCountUnit') }}
            </div>
            <div class="choose-hint">
              {{ $t('SmartLocker.PendingListChooseHint') }}
            </div>
          </div>
          <div class="left-right">
            <el-button round @click="rejectApply(true)">
              {{ $t('SmartLocker.RejectApply') }}
            </el-button>
          </div>
        </div>
        <div class="right">
          {{ $t('SmartLocker.SearchCount', { count: pendingList.length }) }}
        </div>
      </div>
      <div class="list_frame">
        <el-table
          ref="multipleTable"
          v-loading="loadingList"
          tooltip-effect="dark"
          :data="pendingList"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
          />
          <!-- # -->
          <el-table-column
            prop="SerialNum"
            label="#"
            width="70"
            sortable
          >
          </el-table-column>
          <!-- 郵件種類 -->
          <el-table-column
            prop="PostalType"
            :label="$t('SmartLocker.PendingListLabelPostalType')"
            width="120"
            sortable
          >
            <template slot-scope="scope">
              <div>{{ postalTypeList.find((item) => item.value === scope.row.PostalType)?.label || '' }}</div>
              <span class="status-tag waiting">{{ $t('SmartLocker.PendingData') }}</span>
            </template>
          </el-table-column>
          <!-- 收件戶別/收件人 -->
          <el-table-column
            prop="PostalName"
            :label="$t('SmartLocker.PendingListLabelPostalName')"
            sortable
          >
            <template slot-scope="scope">
              <div>{{ scope.row.TabletNote }}</div>
              <div>{{ scope.row.PostalName }}</div>
            </template>
          </el-table-column>
          <!-- 申請入櫃時間 -->
          <el-table-column
            prop="ApplyCreateDate"
            :label="$t('SmartLocker.PendingListLabelApplyCreateDate')"
            width="140"
            sortable
          >
            <template slot-scope="scope">
              <div>{{ $newFormatDate(scope.row.ApplyCreateDate, 'yyyy-MM-dd') }}</div>
              <div>{{ $newFormatDate(scope.row.ApplyCreateDate, 'HH:mm:ss') }}</div>
            </template>
          </el-table-column>
          <!-- 管理人員 -->
          <el-table-column
            prop="AdminName"
            :label="$t('SmartLocker.PendingListLabelAdminName')"
            width="170"
          />
          <!-- 條碼 -->
          <el-table-column
            prop="TransportCode"
            :label="$t('SmartLocker.PendingListLabelTransportCode')"
            width="90"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.TransportCode ? `...${scope.row.TransportCode.slice(-4)}` : '-' }}</div>
            </template>
          </el-table-column>
          <!-- 位置/備註 -->
          <el-table-column
            prop="PostalNote"
            :label="$t('SmartLocker.PendingListLabelNote')"
            width="130"
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="getPostalNote(scope.row.PostalNote)"
                placement="top"
              >
                <div class="postal-note">{{ getPostalNote(scope.row.PostalNote) }}</div>
              </el-tooltip>
              <el-tooltip
                effect="dark"
                :content="getPostalPlace(scope.row.PostalNote)"
                placement="top"
              >
                <div class="postal-note">{{ getPostalPlace(scope.row.PostalNote) }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column
            prop="Action"
            width="120"
            :label="$t('SmartLocker.PendingListLabelAction')"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                plain
                @click.stop="rejectApply(false, scope.row)"
              >
                {{ $t('SmartLocker.RejectApply') }}
              </el-button>
            </template>
          </el-table-column>
          <!-- 詳細資料 -->
          <el-table-column
            prop="Detail"
            :label="$t('SmartLocker.PendingListLabelDetail')"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                plain
                @click.stop="showDetail(scope.row)"
              >
                {{ $t('SmartLocker.Detail') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <rejectApplyDialog ref="rejectApplyDialog" :postalData="rejectApplyPostal" @confirmReject="confirmReject"/>
    <detailDialog ref="detailDialog" :postalDetailId="showDetailId"/>
  </div>
</template>
<script>
import filterFrame from '@/components/FilterFrame'
import rejectApplyDialog from './components/rejectApplyDialog.vue'
import detailDialog from './components/detailDialog.vue'
import { apiPostal } from '@/api/Postal'
import { apiSmartLocker } from '@/api/SmartLocker.js'
import { housekeeperAPI } from '@/api/HousekeeperAPI'
export default {
  components: {
    'filter-frame': filterFrame,
    rejectApplyDialog,
    detailDialog
  },
  data () {
    return {
      pageLoading: false,
      loadingList: false,
      searchRequestData: {},
      tagList: [],
      postalTypeList: [],
      paymentFilter: [
        {
          label: this.$t('SmartLocker.FilterLabelType'),
          name: 'Type',
          type: 'select',
          options: [
            { label: '', value: 'PostalType' },
            { label: '', value: 'PostalLogistics' },
            { label: '', value: 'PostalCompany' }
          ],
          value: ''
        },
        {
          label: this.$t('SmartLocker.FilterLabelTabletTag'),
          name: 'TabletTag',
          type: 'select',
          key: 'tagSelect',
          options: [],
          value: ''
        },
        {
          label: this.$t('SmartLocker.FilterLabelHousehold'),
          name: 'household',
          type: 'house',
          value: ''
        },
        {
          label: this.$t('SmartLocker.FilterLabelTransportCode'),
          name: 'TransportCode',
          type: 'barcode',
          placeholder: this.$t('SmartLocker.TransportCodePlaceholder'),
          value: ''
        },
        {
          label: this.$t('SmartLocker.FilterLabelApplyTime'),
          name: 'ApplyTime',
          type: 'datetime',
          wider: true,
          pickerOptions: {
            default: {
              time: ['00:00:00', '23:59:59']
            }
          }
        }
      ],
      pendingList: [],
      selectionData: [],
      rejectApplyPostal: [],
      showDetailId: ''
    }
  },
  async created () {
    await this.getTagList()
    await this.getTypeList()
  },
  methods: {
    async getTagList () { // 取得棟別
      try {
        const { data } = await housekeeperAPI.getCommunityTabletTag()
        this.tagList = data.Data.Tags.map((item) => { return { value: item.Tag, label: item.Tag } })
        this.paymentFilter[1].options = [...this.tagList]
      } catch (e) {
        console.log(e)
        this.$message({
          message: this.$t('General.GetFail', { name: this.$t('SmartLocker.HouseTag') }),
          type: 'warning'
        })
      }
    },
    async getTypeList () { // 取得包裹類型
      try {
        const res = await apiPostal.GetTypes()
        if (res?.data?.Data?.Lists) {
          const postalTypeData = res.data.Data.Lists.find((item) => item.Type === 'PostalType')
          if (postalTypeData) {
            this.postalTypeList = postalTypeData.List.map((item) => { return { value: item.Id, label: item.Name } })
            this.paymentFilter[0].options = [...this.postalTypeList]
          }
        }
      } catch (e) {
        console.log(e)
        this.$message({
          message: this.$t('General.GetFail', { name: this.$t('SmartLocker.PostalType') }),
          type: 'warning'
        })
      }
    },
    async getList () {
      this.loadingList = true
      this.selectionData = []
      try {
        const res = await apiSmartLocker.GetApplyStorageList(this.searchRequestData)
        if (res?.data?.Data) {
          this.pendingList = res.data.Data.ApplyStorageList || []
        }
      } catch (e) {
        console.log(e)
      }
      this.loadingList = false
    },
    searchHandle (searchVal) {
      this.searchRequestData = {}
      Object.keys(searchVal).forEach((key) => {
        if (key === 'ApplyTime') {
          const startDate = searchVal[key][0]
          const endDate = searchVal[key][1]
          this.searchRequestData.ApplyStorageStartDate = new Date(startDate).toISOString()
          this.searchRequestData.ApplyStorageEndDate = new Date(endDate).toISOString()
        } else if (key === 'household') {
          this.searchRequestData.TabletId = searchVal[key].TabletId
        } else {
          if (searchVal[key]) this.searchRequestData[key] = searchVal[key]
        }
      })
      this.getList()
    },
    rejectApply (isFromSelection, data) {
      this.rejectApplyPostal = []
      if (isFromSelection) {
        if (this.selectionData.length <= 0) return
        this.rejectApplyPostal = JSON.parse(JSON.stringify(this.selectionData))
      } else {
        this.rejectApplyPostal = [data]
      }
      this.$refs.rejectApplyDialog.openDialog()
    },
    async confirmReject (cancelType, cancelReason) {
      try {
        const postalDetailIds = this.rejectApplyPostal.map((item) => item.PostalDetailId)
        const requestData = {
          PostalDetailIds: postalDetailIds,
          CancelType: cancelType,
          CancelReason: cancelReason
        }
        await apiSmartLocker.CancelApplyStorage(requestData)
        const firstPostalData = this.rejectApplyPostal[0]
        this.$message({
          type: 'success',
          message: this.rejectApplyPostal.length <= 1 ? this.$t('SmartLocker.RejectApplySuccessOneData', { number: firstPostalData.SerialNum }) : this.$t('SmartLocker.RejectApplySuccessManyData', { number: postalDetailIds.length })
        })
        this.$refs.rejectApplyDialog.closeDialog()
        this.rejectApplyPostal = []
        this.getList()
        this.$emit('reject')
      } catch (e) {
        console.log(e)
      }
    },
    showDetail (data) {
      this.showDetailId = data.PostalDetailId
      this.$refs.detailDialog.openDialog()
    },
    handleSelectionChange (val) { // checkbox選擇變更
      this.selectionData = _cloneDeep(val)
    },
    getPostalNote (sourceNote) {
      const sourceNotes = sourceNote.split('【位置】')
      const notes = sourceNotes.slice(0, sourceNotes.length > 1 ? sourceNotes.length - 1 : sourceNotes.length)
      return notes.join('【位置】') ? `${this.$t('SmartLocker.Note')}${notes.join('【位置】')}` : ''
    },
    getPostalPlace (sourceNote) {
      const sourceNotes = sourceNote.split('【位置】')
      if (sourceNotes.length <= 1) return ''
      return `${this.$t('SmartLocker.Place')}${sourceNotes[sourceNotes.length - 1]}`
    }
  }
}
</script>

<style lang="scss" scoped>
#pendingList {
  text-align: center;
  padding: 20px 0 10px;
  height: 100%;
  .title_bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0;
    .left {
      width: 50%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid #000;
      border-radius: 10px;
      padding: 20px;
      .left-left {
        text-align: left;
        .choose-count {
          font-size: map-get($fontSize, medium);
          font-weight: bold;
          span {
            margin-inline: 5px;
            color: $mainColor;
          }
        }
        .choose-hint {
          margin-top: 7px;
          font-size: map-get($fontSize, small);
          color: $subFontColor
        }
      }
      .left-right {
        span {
          margin: 0 20px;
          color: $mainFontColor;
          vertical-align: middle;
        }
      }
    }
    .right {
      width: 50%;
      padding-inline: 20px;
      text-align: right;
      color: $mainFontColor;
      font-size: map-get($fontSize, small);
    }
  }
  ::v-deep .el-table {
    @include basicTable;
    .status-tag {
      padding: 4px 6px;
      &.waiting {
        background-color: $orangeFontColor;
        color: white;
      }
    }
    .postal-note {
      color: $mainColor;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
